export default "__VITE_ASSET__2ff1aaea__"